import ChatIconPath from "@ingka/ssr-icon/paths/chat";

export default ChatIconPath;
